// extracted by mini-css-extract-plugin
export default {"routesWrapper":"EditBike_routesWrapper__FBQcK","main":"EditBike_main__9QbJn","title":"EditBike_title__r1ghf"};